import { _addEventListener, removeAllEventListeners } from "../eventHelper";

export default class FocusTrapHelper {
    constructor(focusContainer) {
        this.focusContainer = focusContainer;
        this.init();
    }

    setNewFocusContainer(focusContainer) {
        this.focusContainer = focusContainer;
    }

    getFocusableElements(container) {
        return container.querySelectorAll(
            'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])'
        );
    }

    trapFocus(e, elements) {
        const firstElement = elements[0];
        const lastElement = elements[elements.length - 1];
        if (e.shiftKey && document.activeElement === firstElement) {
            lastElement.focus();
            e.preventDefault();
        } else if (!e.shiftKey && document.activeElement === lastElement) {
            firstElement.focus();
            e.preventDefault();
        }
    }

    handleKeyDown(e) {
        const focusableElements = Array.from(this.getFocusableElements(this.focusContainer));
        if (e.key === "Tab") {
            this.trapFocus(e, focusableElements);
        }
    }

    init() {
        _addEventListener(document, "keydown", (e) => {
            if (this.focusContainer.contains(document.activeElement)) {
                this.handleKeyDown(e);
            }
        });
    }
}
